let $Index = 1;
/**
 * Return next unique object id
 * @returns {string}
 */
export default function getNextUID() {
    const uid = `$${$Index}`;
    $Index += 1;
    return uid;
}
